export default __webpack_public_path__ + "static/6ebdad6051627202e7e126970662dcb1.png";